module.exports = __webpack_public_path__ + "static/media/DIAMOND-13-KING.ba0ccc86.svg";